// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserOrgChart_wrapper__2kjPm","tree":"UserOrgChart_tree__1W6uW","emptyOrgChart":"UserOrgChart_emptyOrgChart__g_oyJ"};